import { useMemo } from 'react';

import type { ColGroupDef } from 'ag-grid-enterprise';

import type { SuppressionFile } from '@enterprise/api';

import DateCellRenderer from '@components/grid/renderers/date-cell.renderer';
import NumberCellRenderer from '@components/grid/renderers/number-cell.renderer';
import TotalCellRenderer from '@components/grid/renderers/total-cell-renderer';

export const useGetSuppressionFileColumns = () => {
  return useMemo(() => {
    return [
      {
        children: [
          {
            field: 'mailingId',
            headerName: 'Mailing ID',
            hide: true,
            width: 125,
          },
          {
            cellRenderer: TotalCellRenderer,
            field: 'fileName',
            headerName: 'File',
            width: 300,
          },
          {
            cellDataType: 'date',
            cellRenderer: DateCellRenderer,
            field: 'fileLoadDate',
            headerName: 'Load Date',
          },
          {
            aggFunc: 'sum',
            cellRenderer: NumberCellRenderer,
            field: 'quantityFileCount',
            headerName: 'Size',
          },
          {
            aggFunc: 'sum',
            cellRenderer: NumberCellRenderer,
            field: 'quantitySuppressed',
            headerName: 'Suppressed',
          },
        ],
      },
    ] as ColGroupDef<SuppressionFile>[];
  }, []);
};
